<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card class="mx-auto my-1" width="374">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>

        <v-img
          v-if="message.src && !look"
          :src="message.src"
          width="100%"
          aspect-ratio=".85"
          cover
        />
        <v-img
          v-else-if="!hover"
          :src="
            message.thumbnail_url ||
            message.picture_url ||
            'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'
          "
          width="100%"
          aspect-ratio=".85"
          cover
        />
        <v-img
          v-else-if="
            hover &&
            Object.keys(message).includes('alternate') &&
            message.alternate &&
            message.alternate.length >= 0
          "
          :src="
            message.alternate[Math.random() >= 0.5 ? 1 : 0] ||
            message.thumbnail_url ||
            message.picture_url
          "
          width="100%"
          aspect-ratio=".85"
          cover
        />
        <v-img
          v-else-if="hover && !message.alternate"
          :src="
            message.thumbnail_url ||
            message.picture_url ||
            'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'
          "
          width="100%"
          aspect-ratio=".85"
          cover
        />

        <v-card-title class="pb-0 pl-4 pt-0 prod_name row" v-if="message.name">
          <h5 class="font-weight-reguler text-truncate col-12">
            {{ message.name }}
          </h5>
        </v-card-title>
        <v-card-text class="pb-1 mb-1">
          <v-row align="center" class="mx-0">
            <v-icon color="amber"> mdi-notification-clear-all </v-icon>

            <div class="grey--text ml-3">
              {{
                message.categories
                  ? message.categories[message.categories.length - 1]
                  : "-"
              }}
            </div>
          </v-row>
        </v-card-text>

        <v-divider class="mx-4"></v-divider>

        <v-card-title class="pb-2" v-show="message.price">
          <v-row align="center" dense no-gutters>
            <v-col cols="12" sm="6" class="subtitle-1 text-center">
              <span>{{ message.price || "-" }}€ </span>
            </v-col>
            <v-col
              v-if="message.price_old"
              cols="12"
              sm="6"
              class="subtitle-1 text-center"
            >
              <strike>
                {{ numberWithSpaces(message.price_old) || "-" }}€
              </strike>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: "Chat_message_card",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
    look: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({}),
  created() {
    //console.log('-->', this.message, this.message.src, this.look);
  },
  methods: {
    numberWithSpaces(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      return 0;
    },
  },
};
</script>
<style scoped></style>
